import { Routes } from '@angular/router';
import { authGuard, authenticatedGuard, moduleGuard } from '@core/guards';

/** Dispensaciones and Tareas: whoever dispenses, supervises or audits — the
 *  same roles the menu offers them to and the backend's BoardPermission serves. */
const BOARD_MODULES = [
  'view_farmaceuta_module',
  'view_supervisor_module',
  'view_auditoria_module',
] as const;

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [authenticatedGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'menu',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/main-menu/main-menu.component').then((m) => m.MainMenuComponent),
  },
  {
    path: 'orientador',
    canActivate: [authGuard, moduleGuard('view_orientador_module')],
    loadComponent: () =>
      import('./pages/orientador/orientador.component').then((m) => m.OrientadorComponent),
  },
  {
    // Por dispensar (rediseño de datos C, 2026-10-21): what is still to
    // dispense — the orientador's too, who loads it.
    path: 'por-dispensar',
    canActivate: [authGuard, moduleGuard('view_orientador_module', ...BOARD_MODULES)],
    loadComponent: () =>
      import('./pages/por-dispensar/por-dispensar.component').then((m) => m.PorDispensarComponent),
    // One row opened on top of the table: the PRE-DISPENSATION's id. A child
    // with no component of its own, so opening and closing a row keeps the
    // table — its filters, its page — exactly where it was.
    children: [{ path: ':id', children: [] }],
  },
  {
    // One row per ERP dispensation, whatever brought it.
    path: 'dispensaciones',
    canActivate: [authGuard, moduleGuard(...BOARD_MODULES)],
    loadComponent: () =>
      import('./pages/dispensaciones/dispensaciones.component').then(
        (m) => m.DispensacionesComponent,
      ),
    // The DISPENSATION's id, opened the same way.
    children: [{ path: ':id', children: [] }],
  },
  {
    // Tareas (PLAN_REDISENO fase 2): whoever may open Dispensaciones.
    path: 'tareas',
    canActivate: [authGuard, moduleGuard(...BOARD_MODULES)],
    loadComponent: () => import('./pages/tareas/tareas.component').then((m) => m.TareasComponent),
  },
  {
    // Análisis (fase 4): the data-analysis agent's chat. `:id` is the open
    // conversation, a componentless child so the page keeps its list.
    path: 'analisis',
    canActivate: [authGuard, moduleGuard('view_inteligencia_module')],
    loadComponent: () =>
      import('./pages/analisis/analisis.component').then((m) => m.AnalisisComponent),
    children: [{ path: ':id', children: [] }],
  },
  // The two Kanban and Reportes went in PLAN_REDISENO fase 2c: old links land
  // where their work lives now (Reportes is Análisis since fase 4).
  { path: 'auditoria', redirectTo: 'dispensaciones', pathMatch: 'full' },
  { path: 'auditoria/:id', redirectTo: 'dispensaciones', pathMatch: 'full' },
  { path: 'subsanaciones', redirectTo: 'tareas', pathMatch: 'full' },
  { path: 'subsanaciones/:id', redirectTo: 'tareas', pathMatch: 'full' },
  { path: 'reportes', redirectTo: 'analisis', pathMatch: 'full' },
  // The regente's code is a dialog in the sidebar's profile block, not a page.
  { path: 'regente', redirectTo: 'menu', pathMatch: 'full' },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/access-denied/access-denied.component').then((m) => m.AccessDeniedComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
